import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component'
import { TableComponent } from './table/table.component';

const routes: Routes = [{
    path: '',
    children: [
        {
            path: '',
            component: DashboardComponent,
            data: { title: "Participants" }

        },
        {
            path: 'table',
            component: TableComponent,
            data: { title: "Table Seating" }

        },
    ]
},];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class DashboardRoutingModule { }
